module.exports = __webpack_public_path__ + "img/confused.f96e42f8.svg";